import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import BrandContext from './BrandContext';
import isValidBrand from './isValidBrand';

/**
 * Provider to enable context
 *
 * @param single brand string
 * @param children
 * @returns {*}
 * @constructor
 */
export default function BrandProvider(_ref) {
  let {
    brand = '',
    children
  } = _ref;
  isValidBrand(brand);
  return /*#__PURE__*/_jsx(BrandContext.Provider, {
    value: brand
  }, void 0, children);
}